<script>
import Router from '@/router/index.js'
import modalWindow from '@/components/ModalWindow'
import Store from '@/store/index.js'
import { recordTreeViewer, getViewsOfTree } from '@/api/FirebaseViewWrapper.js'
import { getTouchSpeed, removeUrl, hasAdminRole, getMembersNewNode, getQuestionsForTree } from '@/api/Utilities.js'
import 'bulma/css/bulma.css'
import graph from './graph/Graph'
import postCard from './postCard'
import nodeCard from './nodeCard'
import boardCard from './boardCard'
import * as constant from '@/constant/constant.js'
// v9 moduler 方式
import { firebaseApp } from '@/firebase.js'
import { getFirestore, collection, query, onSnapshot } from 'firebase/firestore'
import { getAnalytics, logEvent } from 'firebase/analytics'
import { getMyUserId, getMyUserData } from '@/api/FirebaseUserWrapper.js'
import { getMembersByTeamId } from '@/api/FirebaseTeamWrapper.js'
import { deleteTree, deleteNode, getTreeFromTreeId } from '@/api/FirebaseTreesWrapper.js'

const db = getFirestore(firebaseApp)
const analytics = getAnalytics(firebaseApp)

require('../../css/style.css')
var clipboard = new ClipboardJS('.share_copy')

export default {
  components: {
    graph,
    modalWindow,
    postCard,
    nodeCard,
    boardCard
  },
  props: ['boardcards'],
  data () {
    return {
      listener: undefined,
      tree: {},
      nodes: {},
      questionsForTree: [],
      targetNode: {}, // graphでclickされたNode
      views: 0,
      nodesNum: 0,
      maxNodes: 101, /* root node を含む tree の Node最大数 */
      directUrl: '',
      isSolved: false, // TreeがCLOSEされたらTrue
      isDeleted: false, // Treeの削除が実行されたらTrue
      treeActive: false, // Treeが有効になったTrue
      loginUserId: '', // Treeを閲覧しているユーザーのuserId
      isTeamOwner: false, // teamのOwnerならTrue
      clickNodeId: '', // graphでclickされたNodeのId
      focusingTextId: '', // PostcardのtextareaでfocusされたId
      clickAddQuestionFlag: false, // graphaddQuestionが押された
      enableNodeCard: false,
      enablePostCard: false,
      cardHeight: 85,
      highlightSelect: {id: '', group: ''}, // selectされているidのnode or edgeをHighlight
      latestQuestion: {id: '', number: '', userId: ''}, // 最新のquestionの情報を保持
      navigation: '',
      updatingMsg: constant.DEFAULT_UPDATING_MSG,
      edittingMsg: '',
      isMouseDown: false,
      enableTreeDeleteModal: false,
      enableCopyModal: false,
      isCompletedCopy: false,
      isAnonymousModal: false,
      enableDeleteNode: false,
      deleteNodeMsg: 'このカードを削除しますか？', // 質問削除時の警告メッセージ
      deleteNodeId: '',
      deleteNode: {},
      graphScale: 1.0, // graphのschale値
      previousScale: 1.0, // graphの直前のschele値
      graphHeight: 0, // graphの高さ
      graphWidth: 0, // graphの幅
      graphMinWidth: 0, // graphのroot Node(x,y)=(0,0)に対して-x側の最大値
      graphMaxWidth: 0, // graphのroot Node(x,y)=(0,0)に対して+x側の最大値
      graphTranslateX: 0,
      graphTranslateY: 0,
      initialGraphTranslateX: 0, // panする瞬間の初期位置X
      initialGraphTranslateY: 0, // panする瞬間の初期位置Y
      touchStartX: 0,
      touchStartY: 0,
      touchStartTime: 0,
      touchDeltaX: 0,
      touchDeltaY: 0,
      touchDeltaTime: 0,
      touchSpeedX: 0,
      touchSpeedY: 0,
      queryNodeNum: 0,
      members: [],
      membersNewNode: [],
      resizeObserver: undefined,
      isResizeObserver: false,
      enableEditQuestion: false,
      title: constant.DEFAULT_DOMAIN_TITLE,
      enableBoardCard: false,
      targetCard: {},
      enableBoard: false, // ボードの可視化
      boardCardData: [],
      isDisablePan: false, // グラフのパンを無効化するためのフラグ.
      previousTree: {},
      offsetX: 0, // graphのx座標
      offsetY: 0, // graphのy座標
      mouseTarget: null, // mouse eventのtarget
      nodeDirection: 'depth'
    }
  },
  async beforeDestroy () {
    if (this.listener) { this.listener() }
    this.resizeObserver.unobserve(this.$refs.tree) // 検知終了
    this.resizeObserver.disconnect(this.$refs.tree) // 開放
    await this.deleteNoUpdateTree()
    document.title = this.title
    document.querySelector("meta[property='og:title']").setAttribute('content', this.title)
  },
  async created () {
    await this.showTree()
  },
  async mounted () {
    // query paramがある場合はそのNodeにフォーカスする
    if (this.$route.query.node) {
      this.queryNodeNum = Number(this.$route.query.node)
    }
    // サイドバーで動的に画面幅が変わるので検知するリスナーを貼る
    this.graphWidth = this.$refs.tree.getBoundingClientRect().width
    this.resizeObserver = new ResizeObserver((entries, observer) => {
      this.isResizeObserver = !this.isResizeObserver
    })
    this.resizeObserver.observe(this.$refs.tree)
  },
  watch: {
    nodesNum: function () {
      if (this.nodesNum >= this.maxNodes) {
        this.isSolved = true
      }
    },
    async $route (to, from) {
      // clip pathが消えたら初期化
      if (!to.query.clip) {
        this.previousTree = {}
      }

      // ルートの変更の検知...user/:A to user/:Bの際に画面描画されないため
      if (from.path !== to.path) {
        // treeの再取得
        await this.showTree()
        // clip元から飛んできた場合
        if (from.name === 'Tree' && to.query.clip) {
          this.previousTree.path = from.path
          this.previousTree.node = from.query.node ? from.query.node : 0
        }
      }
      // query pathが変更されたら発火してfocusするnode numを変更
      if (!to.query.click) {
        this.queryNodeNum = Number(to.query.node)
      } else {
        this.queryNodeNum = -1
      }
    },
    isResizeObserver: function () {
      this.handleResize()
    },
    boardcards: function () {
      this.boardCardData = this.boardcards
    }
  },
  methods: {
    handleResize: function () {
      this.graphWidth = this.$refs.tree.getBoundingClientRect().width
      this.questionsForTree.splice()
      this.boardCardData.splice()
    },
    async deleteNoUpdateTree () {
      // 無題Treeが放置された場合は削除
      if (this.questionsForTree.length === 1 &&
      this.questionsForTree[0].question === constant.DEFAULT_ROOT_MSG
      ) {
        this.isDeleted = true
        await deleteTree(this.tree.id)
      }
    },
    async showTree () {
      // 初期化
      await this.init()
      // Tree情報の取得
      this.loginUserId = await getMyUserId()
      const myData = await getMyUserData(this.loginUserId)
      this.navigation = myData.navigation
      this.enableBoard = myData.clipBoardFlag
      this.nodeDirection = myData.nodeDirection
      // スマホ画面の場合は強制False
      if (window.innerWidth < 768) {
        this.enableBoard = false
      }
      this.tree = await getTreeFromTreeId(this.$route.params.treeId)
      // treeが存在しなければdelete flagを立ててreturn
      if (!this.tree) {
        this.isDeleted = true
        return
      }
      this.isSolved = this.tree.solved

      // teamの情報取得
      this.members = await getMembersByTeamId(this.tree.scope)
      const targetIndex = this.members.findIndex(({userId}) => userId === this.loginUserId)
      // teamOwnerの判定
      if (targetIndex !== -1 && this.members[targetIndex].role === 'owner') {
        this.isTeamOwner = true
      }

      // Boardの設定 App.vueにBoardのTree scopeをアップデート
      this.$emit('showBoard', this.tree.scope)

      // View数関係
      await recordTreeViewer(this.tree.id)
      this.views = await getViewsOfTree(this.tree.id, this.tree.userId)

      // header設定
      const title = removeUrl(this.tree.issue) + ' | ' + this.title
      document.title = title
      document.querySelector("meta[property='og:title']").setAttribute('content', title)

      // =================== GOOGLE ANALYTICS ===================
      if (hasAdminRole(this.loginUserId)) {
        console.log('YOU ARE DEVELOPPER AND EXCLUDED FROM ANALYSIS')
      } else {
        logEvent(analytics, 'tree/Tree')
        logEvent(analytics, 'tree_view', {
          tree_id: this.$route.params.treeId
        })
      }
      // nodesのlistenrを作る v9 moduler
      const nodesQuery = query(collection(db, 'treesV2/' + this.tree.id + '/nodes'))
      this.listener = onSnapshot(nodesQuery, (snapshot) => {
        snapshot.docChanges().forEach((change) => {
          // 日付が入っていない場合はreturn
          if (!change.doc.data().createdAt || !change.doc.data().order) { return }
          // 追加時
          if (change.type === 'added' && change.doc.data().question) {
            this.nodes[change.doc.id] = change.doc.data()
            // Nodeの総数
            if (this.nodes[change.doc.id].number >= this.nodesNum) {
              this.nodesNum = this.nodes[change.doc.id].number + 1
            }
          }
          // 修正（更新時)-日付なしはreturnしたことで新規追加がこちらで発火するケースもあり
          if (change.type === 'modified' && change.doc.data().question) {
            this.nodes[change.doc.id] = change.doc.data()
            // rootの修正時はタイトルを変更
            if (change.doc.data().marker === 'root') {
              // header設定
              const title = removeUrl(change.doc.data().question) + ' | ' + this.title
              document.title = title
              document.querySelector("meta[property='og:title']").setAttribute('content', title)
            }
            // Nodeの総数
            if (this.nodes[change.doc.id].number >= this.nodesNum) {
              this.nodesNum = this.nodes[change.doc.id].number + 1
            }
          }
          // 修正（削除時)
          if (change.type === 'modified' && !change.doc.data().question) {
            delete this.nodes[change.doc.id]
          }
          // 完全削除時
          if (change.type === 'removed') {
            delete this.nodes[change.doc.id]
          }
        })
        ;[this.questionsForTree, this.latestQuestion] = getQuestionsForTree(this.nodes)
        this.membersNewNode = getMembersNewNode(this.questionsForTree, this.members)
        this.treeActive = true
      })
      this.directUrl = location.href
    },
    async init () {
      if (this.treeActive) {
        await this.deleteNoUpdateTree()
        this.listener()
      }
      this.graphTranslateX = 0
      this.graphTranslateY = 0
      this.treeActive = false
      this.isDeleted = false
      this.enableTreeDeleteModal = false
      this.questionsForTree = []
      this.nodes = {}
      this.targetNode = {}
      this.highlightSelect = {id: '', group: ''}
      this.enableNodeCard = false
      this.enablePostCard = false
      this.enableBoardCard = false
      this.clickAddQuestionFlag = false
      this.nodesNum = 0
      this.updatingMsg = constant.DEFAULT_UPDATING_MSG
      this.members = []
      this.previousTree = {}
      this.isTeamOwner = false
    },
    /* ------------ nodeのicon関連の操作 ------------ */
    // edgeをclick
    async clickEdge (id) {
      this.enableNodeCard = false
      this.enableBoardCard = false
      this.updatingMsg = constant.DEFAULT_UPDATING_MSG
      this.highlightSelect.id = id
      this.highlightSelect.group = 'edges'
      this.questionsForTree.splice()
    },
    // boardCardをclick
    clickCard (card) {
      this.enableBoardCard = true
      this.enableNodeCard = false
      this.enablePostCard = false
      this.enableEditQuestion = false
      this.clickAddQuestionFlag = false
      this.targetCard = card
    },
    // nodeをclick
    clickNode (id, posx, posy, isFocusingNode) {
      this.enableBoardCard = false
      this.enableNodeCard = true
      this.enablePostCard = true
      this.enableEditQuestion = false
      this.clickAddQuestionFlag = false
      this.clickNodeId = id
      this.targetNode = this.nodes[id]
      this.highlightSelect.id = id
      this.highlightSelect.group = 'nodes'
      if (isFocusingNode) {
        this.graphTranslateX = posx
        this.graphTranslateY = posy
      }
      this.questionsForTree.splice()
    },
    // nodeの追加
    addQuestion (id, posx, posy) {
      this.enableBoardCard = false
      this.enableNodeCard = true
      this.enablePostCard = true
      this.enableEditQuestion = false
      this.clickAddQuestionFlag = true
      if (window.innerWidth < 768) {
        this.graphTranslateY = posy
      }
      this.clickNodeId = id
      // thargetQuestionを代入
      this.targetNode = this.nodes[id]
      this.queryNodeNum = -1
    },
    // nodeの削除
    deleteQuestion (id) {
      this.highlightSelect = {id: '', group: ''}
      this.enableDeleteNode = true
      this.deleteNodeId = id
      this.deleteNode = this.nodes[id]
    },
    async doNodeDelete () {
      await deleteNode(this.tree.id, this.deleteNodeId)
      this.enableNodeCard = false
      this.enablePostCard = false
      this.enableDeleteNode = false
    },
    cancelNodeDelete () {
      this.enableDeleteNode = false
    },
    // nodeの編集
    editQuestion (id) {
      this.enableEditQuestion = true
      this.enableBoardCard = false
      this.enableNodeCard = true
      this.enablePostCard = false
      this.clickNodeId = id
      this.targetNode = this.nodes[id]
    },
    endEditQuestion () {
      this.enableEditQuestion = false
      this.enableBoardCard = false
      this.enableNodeCard = true
      this.enablePostCard = true
    },
    showAnonymousAlert (id) {
      this.isAnonymousModal = true
    },
    updatingText (msg) {
      if (!msg) {
        msg = constant.DEFAULT_UPDATING_MSG
      }
      this.updatingMsg = msg
    },
    edittingText (msg) {
      this.edittingMsg = msg
    },
    focusingTextarea (id) {
      this.focusingTextId = id
    },
    /* ------------ graphのタッチ・マウス関連の操作 ------------ */
    getGraphHeight (height) {
      this.graphHeight = height
    },
    getGraphWidth (minWidth, maxWidth) {
      this.graphMinWidth = minWidth
      this.graphMaxWidth = maxWidth
    },
    onGraphPinch (e) {
      let scale = this.graphScale
      let delta = e.scale - this.previousScale
      // scaleが大きく変化するのを歯止め、最大変化量0.05にする
      if (delta > 0.05) {
        delta = 0.05
      } else if (delta < -0.05) {
        delta = -0.05
      }
      scale += delta
      scale = Math.min(Math.max(0.25, scale), 2.0)
      this.graphScale = scale
      this.previousScale = e.scale
    },
    onGraphPan (e) {
      if (this.isDisablePan) { return }
      this.graphTranslateX = this.initialGraphTranslateX + e.deltaX / this.graphScale
      this.graphTranslateY = this.initialGraphTranslateY + e.deltaY / this.graphScale
    },
    disablePan () {
      // ノードのドラッグ中に呼ばれる.
      // グラフのパンを無効化する.
      this.isDisablePan = true
    },
    enablePan () {
      // ノードのドラッグが終わったら呼ばれる.
      // グラフのパンを有効化する.
      this.isDisablePan = false
    },
    onGraphDown (e) {
      // mouse down開始したらTrue
      this.isMouseDown = true
      // 初期化
      this.initialGraphTranslateX = this.graphTranslateX
      this.initialGraphTranslateY = this.graphTranslateY
      // Touchの初期化
      this.touchDeltaX = 0
      this.touchDeltaY = 0
      // 初期位置代入
      this.touchStartX = e.offsetX
      this.touchStartY = e.offsetY
      this.touchStartTime = e.timeStamp
    },
    onGraphMove (e) {
      // Mouseのhover操作ならreturn
      if (!this.isMouseDown) { return }
      // offset座標
      this.offsetX = e.offsetX
      this.offsetY = e.offsetY
      this.mouseTarget = e.target.className
      // 前回のTouchとの差分を取得
      this.touchDeltaX = e.offsetX - this.touchStartX
      this.touchDeltaY = e.offsetY - this.touchStartY
      this.touchDeltaTime = (e.timeStamp - this.touchStartTime) / 1000.0
      // 初期値を更新
      this.touchStartX = e.offsetX
      this.touchStartY = e.offsetY
      this.touchStartTime = e.timeStamp
      // 移動中はnodeを非表示
      if (!this.enableEditQuestion) {
        this.enableNodeCard = false
      }
    },
    async onGraphUp (e) {
      // offset座標
      this.offsetX = 0
      this.offsetY = 0
      // Drag操作終了したのでFalse
      this.isMouseDown = false
      // 時間が0なら発散するのでreturn
      if (this.touchDeltaTime === 0) { return }
      // 吹っ飛びが発生したらreturn
      if (Math.abs(this.touchDeltaX) > 100 && Math.abs(this.touchDeltaY) > 100) { return }
      // 初期速度の計算
      this.touchSpeedX = Math.sqrt(this.touchDeltaX * this.touchDeltaX) / this.touchDeltaTime
      this.touchSpeedY = Math.sqrt(this.touchDeltaY * this.touchDeltaY) / this.touchDeltaTime

      let initSpeedX = this.touchSpeedX
      let initSpeedY = this.touchSpeedY
      let timeCount = 0
      // console.log('initSpeedX:' + initSpeedX)
      // console.log('initSpeedY:' + initSpeedY)
      // speedが1以下 or Dragではなく、moveを介さないdown→upのクリック動作の場合はbrake
      while (this.touchSpeedX > 1 || this.touchSpeedY > 1) {
        // 再クリックされたらスピート初期化
        if (this.isMouseDown) {
          initSpeedX = 0
          initSpeedY = 0
          this.touchSpeedX = 0
          this.touchSpeedY = 0
        }
        const deltaX = Math.min(Math.max(-200, Math.sign(this.touchDeltaX) * this.touchSpeedX / 100.0), 200)
        const deltaY = Math.min(Math.max(-200, Math.sign(this.touchDeltaY) * this.touchSpeedY / 100.0), 200)
        // console.log('Mouse deltaX: ' + deltaX)
        // console.log('Mouse deltaY: ' + deltaY)
        // x方向の計算
        this.graphTranslateX += deltaX
        this.graphTranslateX = Math.min(Math.max(this.graphMinWidth, this.graphTranslateX), this.graphMaxWidth)
        // y方向の計算
        this.graphTranslateY += deltaY
        this.graphTranslateY = Math.min(Math.max(this.graphHeight, this.graphTranslateY), 250)

        timeCount++
        // 慣性Speedの計算
        const touchSpeedArray = await getTouchSpeed(initSpeedX, initSpeedY, timeCount)
        this.touchSpeedX = touchSpeedArray[0]
        this.touchSpeedY = touchSpeedArray[1]
        // console.log('speedX:' + this.touchSpeedX)
        // console.log('speedY:' + this.touchSpeedY)
      }
    },
    onGraphWheel (e) {
      e.preventDefault()
      let scale = this.graphScale
      let deltaX = Math.min(Math.max(-10, e.deltaX), 10)
      let deltaY = Math.min(Math.max(-10, e.deltaY), 10)
      // console.log('navigation: ' + this.navigation)
      // console.log('x: ' + deltaX)
      // console.log('y: ' + deltaY)
      // console.log(e)
      // トラックパッドモード
      if (this.navigation === 'trackpad') {
        if (Number.isInteger(e.deltaX * 100) && Number.isInteger(e.deltaY * 100)) {
          // x方向
          this.graphTranslateX += deltaX * -3.0
          this.graphTranslateX = Math.min(Math.max(this.graphMinWidth, this.graphTranslateX), this.graphMaxWidth)
          // y方向
          this.graphTranslateY += deltaY * -3.0
          this.graphTranslateY = Math.min(Math.max(this.graphHeight, this.graphTranslateY), 250)
          // console.log('Wheel graphX: ' + this.graphTranslateX)
          // console.log('Wheel graphY: ' + this.graphTranslateY)
          // 移動中はnodeを非表示
          if (!this.enableEditQuestion) {
            this.enableNodeCard = false
          }
        } else {
          scale += deltaY * -0.01
          scale = Math.min(Math.max(0.125, scale), 4)
          this.graphScale = scale
        }
      // マウスモード
      } else {
        // console.log('e.scale: ' + e.scale)
        scale += deltaY * -0.01
        // console.log('scale: ' + scale)
        scale = Math.min(Math.max(0.125, scale), 4)
        // console.log('scale FINAL: ' + scale)
        this.graphScale = scale
      }
    },
    onTransferFocusingNode (selector, focusedNodeNum) {
      this.queryNodeNum = focusedNodeNum
      this.selector = selector
    },
    /* ------------ graph icon関連の操作 ------------ */
    expandV () {
      this.enableNodeCard = false
      this.enablePostCard = false
      this.enableBoardCard = false
    },
    toggleBoard () {
      this.enableBoard = !this.enableBoard
    },
    thumbtackOrigin () {
      this.graphTranslateX = 0
      this.graphTranslateY = 0
    },
    zoomIn () {
      let scale = this.graphScale
      scale += 0.15
      scale = Math.min(Math.max(0.125, scale), 4)
      this.graphScale = scale
    },
    zoomOut () {
      let scale = this.graphScale
      scale += -0.15
      scale = Math.min(Math.max(0.125, scale), 4)
      this.graphScale = scale
    },
    goNewNode (number) {
      if (!number) { return }
      this.queryNodeNum = number
    },
    /* ------------ Treeのicon関連の操作 ------------ */
    // urlのcopy
    clickCopyIcon () {
      this.enableCopyModal = true
    },
    colseCopyModal () {
      this.enableCopyModal = false
    },
    closeCopy () {
      this.colseCopyModal()
      this.isCompletedCopy = false
    },
    copyConfirm () {
      let vm = this
      clipboard.on('success', function () {
        vm.isCompletedCopy = true
      })
      clipboard.on('error', function () {
        console.log('copy error')
      })
    },
    // treeの削除
    clickDeleteBtn () {
      this.enableTreeDeleteModal = true
    },
    closeTreeDeleteModal () {
      this.enableTreeDeleteModal = false
    },
    async doTreeDelete () {
      // vue全体を非表示にしてv-forを回さないことでErrorを避ける
      this.isDeleted = true
      // listenerを排除する
      this.listener()
      // Treeの削除
      await deleteTree(this.tree.id)
      this.enableTreeDeleteModal = false
      Router.push({ path: '/', query: { team: `${this.tree.scope}` } })
    },
    // 匿名user関連
    clickSetViewingPage () {
      const path = '/tree/' + this.tree.id
      Store.commit('setViewingPage', path)
    },
    closeAnonymousModal () {
      this.isAnonymousModal = false
    }
  },
  filters: {
    htmlEscape (str) {
      if (!str) { return }
      return str.replace(/[<>&"'`]/g, (match) => {
        const escape = {
          '<': '&lt;',
          '>': '&gt;',
          '&': '&amp;',
          '"': '&quot;',
          "'": '&#39;',
          '`': '&#x60;'
        }
        return escape[match]
      })
    }
  }
}
</script>
<style scoped>
.card .card-content .content {
  margin: auto;
}
.card .card-content .content .buttons {
  width: 50%;
  position: absolute;
}
.card .card-content .content .buttons .button {
  z-index: 1;
}
.column {
  padding-left: 0;
}
.add-margintop {
  margin-top: 0.0rem
}
.buttons:last-child {
  margin-bottom: 0rem;
}
.tabs a {
  border-bottom-width: 0px;
}
.tabs .icon:first-child {
  margin-right: 0.0em;
}
.tabs .icon:last-child {
  margin-left: 0.0em;
}
.bottom-tab {
  background-color: #fcfcfc;
}
.tabs ul {
  border-bottom-width: 0px;
}
.is-size-8 {
  font-size: 0.5rem !important;
}
.graph {
  /*
  position: absolute;
  width: 100%;
  height: 100%;
  */
  -ms-overflow-style: none;
  scrollbar-width: none;
}
.graph::-webkit-scrollbar {
  display:none;
}
.layer1 {
  top: 0rem;
}
.layer2 {
  top: 1.8rem;
  width: min-content !important;
}
.layer3 {
  top: 3.6rem;
  width: min-content !important;
}
.layer4 {
  top: 5.4rem;
  width: min-content !important;
}
.half-transparent {
  opacity: 0.3;
}
.image img {
  height: 100%;
}
.is-back-white {
  background-color: white;
}
.is-padding-less {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  padding-bottom: 0.5rem;
  padding-top: 0.5rem;
}
.fixed-bottom {
  bottom: 0;
  position: fixed;
}
</style>
<template>
  <div class="tree">
    <div class="delete-tree" v-if="isDeleted">
      <br>
      <p class="text has-text-danger">
        削除または非公開のTreeです
      </p>
      <br>
      <router-link class="button is-link is-outlined has-text-weight-bold" to="/">
        <span>Homeに戻る</span>
      </router-link>
    </div>
    <!-- tree関連 -->
    <div class="tree-data" ref="tree">
      <div class="has-data" v-if="!isDeleted">
        <div class="card add-margintop" ref="TreeWindow" style="overflow:hidden"
        v-on:mousedown="onGraphDown"
        v-on:touchstart="onGraphDown"
        v-on:wheel="onGraphWheel"
        v-on:touchmove="onGraphMove"
        v-on:mousemove="onGraphMove"
        v-on:mouseup="onGraphUp"
        v-on:touchend="onGraphUp"
        v-pinch="onGraphPinch"
        v-pan="onGraphPan">
          <div class="card-content is-paddingless">
            <div class="content" v-if="treeActive" v-bind:style="{ height: cardHeight + 'vh' }">
              <div class="columns is-multiline is-mobile is-marginless">
                <div class="column is-paddingless is-half">
                  <div class="buttons layer1 has-addons is-left">
                    <a class="button is-small" @click="thumbtackOrigin()">
                      <span class="icon">
                        <i class="fa-solid fa-thumbtack"></i>
                      </span>
                    </a>
                    <a class="button is-small is-hidden-mobile" @click="toggleBoard()" v-bind:class="{ 'is-link' : enableBoard}">
                      <span class="icon">
                        <i class="fa-solid fa-clipboard"></i>
                      </span>
                    </a>
                  </div>
                </div>
                <div class="column is-paddingless" v-if="members">
                  <div class="buttons layer1 has-addons is-right">
                    <div  v-for="member in membersNewNode" :key="member.userId">
                      <a class="button is-padding-less is-small" v-bind:class="{ 'is-light': !member.hasNode }" @click="goNewNode(member.newNode)">
                        <div class="image is-24x24" v-bind:class="{ 'half-transparent': !member.hasNode }">
                          <img class="is-rounded" :src="member.imageUrl">
                          <!--<span class="text is-back-white is-size-8">#{{member.newNode}}</span>-->
                        </div>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div class="buttons layer2 has-addons is-left">
                <a class="button is-left is-small" @click="zoomIn()">
                  <span class="icon">
                    <i class="fa-regular fa-plus-square"></i>
                  </span>
                </a>
              </div>
              <div class="buttons layer3 has-addons is-left">
                <a class="button is-left is-small" @click="zoomOut()">
                  <span class="icon">
                    <i class="fa-regular fa-minus-square"></i>
                  </span>
                </a>
              </div>
              <div class="buttons layer4 has-addons is-left">
                <a class="button is-left is-small" @click="expandV()">
                  <span class="icon">
                    <i class="fa-solid fa-expand"></i>
                  </span>
                </a>
              </div>
              <graph class="graph"
              :treeId="tree.id"
              :isTeamOwner="isTeamOwner"
              :maxBranchNum = "tree.maxBranchNum"
              :team = "tree.scope"
              :questions="this.questionsForTree"
              :updatingMsg = "updatingMsg"
              :edittingMsg = "edittingMsg"
              :focusingTextId = "focusingTextId"
              :loginUserId = "loginUserId"
              :selector="this.highlightSelect"
              :scale="this.graphScale"
              :translateX="this.graphTranslateX"
              :translateY="this.graphTranslateY"
              :isSolved = "isSolved"
              :nodesNum = "nodesNum"
              :latestQuestion = "latestQuestion"
              :queryNodeNum = "queryNodeNum"
              :graphWidth = "graphWidth"
              :members = "members"
              :isMouseDown = "isMouseDown"
              :offsetX="offsetX"
              :offsetY="offsetY"
              :mouseTarget="mouseTarget"
              :boardCardData="boardCardData"
              :enableBoard="enableBoard"
              :nodeDirection="nodeDirection"
              @clickCard="clickCard"
              @clickNode="clickNode"
              @clickEdge="clickEdge"
              @clickAddQuestion="addQuestion"
              @clickDeleteQuestion="deleteQuestion"
              @clickEditQuestion="editQuestion"
              @alertAnonymous="showAnonymousAlert"
              @graphHeight="getGraphHeight"
              @graphWidth="getGraphWidth"
              @transferFocusingNode="onTransferFocusingNode"
              @startMoveBranch="disablePan"
              @endMoveBranch="enablePan"
              >
              </graph>
            </div>
          </div>
        </div>
        <div class="fixed-bottom" v-bind:style="{ width: graphWidth + 'px' }">
          <boardCard v-if="enableBoardCard"
          :card = "targetCard"
          :teamId = "tree.scope"
          :loginUserId="loginUserId"
          :enableEditNode = "false"
          class="boardcard"
          />
          <nodeCard v-if="enableNodeCard && clickNodeId"
          :question = "targetNode"
          :nodeId = "clickNodeId"
          :loginUserId="loginUserId"
          :treeId="tree.id"
          :enableEditQuestion = "enableEditQuestion"
          :members="members"
          :previousTree = "previousTree"
          @edittingText = "edittingText"
          @endEditQuestion = "endEditQuestion"
          class="nodecard"
          />
          <postCard v-if="enablePostCard && !isSolved"
          :nodeId = "clickNodeId"
          :addQuestionFlag = "clickAddQuestionFlag"
          :loginUserId="loginUserId"
          :treeId="tree.id"
          :nodesNum = "nodesNum"
          :members = "members"
          :team = "tree.scope"
          :boardCardData = "boardCardData"
          @updatingText = "updatingText"
          @focusingTextarea = "focusingTextarea"
          class="postCard"
          />
          <div class="bottom-tab">
            <div class="tabs is-right is-small">
              <ul>
                <li>
                  <div class="tags">
                    <span class="tag is-dark is-size-8" v-if="!isSolved && nodesNum < maxNodes">
                      受付中
                    </span>
                    <span class="tag is-dark is-size-8" v-else>
                      CLOSE
                    </span>
                  </div>
                </li>
                <li>
                  <p class="text is-size-7">
                    &nbsp;
                    {{this.views}} views
                    &nbsp;
                  </p>
                </li>
                <li>
                  <p class="text has-text-weight-bold is-size-7">
                    Q: {{nodesNum - 1}}
                  </p>
                </li>
                <li @click="clickDeleteBtn()" v-if="isTeamOwner">
                  <a>
                    <span class="icon is-small">
                      <i class="fa-solid fa-lg fa-trash" aria-hidden="true"></i>
                    </span>
                  </a>
                </li>
                <li @click="clickCopyIcon()">
                  <a>
                    <span class="icon is-small">
                      <i class="fa-solid fa-lg fa-share-alt" aria-hidden="true"></i>
                    </span>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="delete-node-modal-window">
          <modalWindow @close="cancelNodeDelete()" v-if="enableDeleteNode">
            <template slot="header">
              <div class="buttons is-right">
                <button class="delete" @click="cancelNodeDelete()"></button>
              </div>
            </template>
            <p>{{deleteNodeMsg}}</p>
            <template slot="footer">
              <div class="buttons is-centered">
                <button class="button" @click="cancelNodeDelete()">キャンセル</button>
                &nbsp;
                &nbsp;
                &nbsp;
                <button class="button is-link" @click="doNodeDelete()">削除</button>
              </div>
            </template>
          </modalWindow>
        </div>
        <br>
        <div class="delete-tree-modal-window">
          <modalWindow @close="closeTreeDeleteModal" v-if="enableTreeDeleteModal">
            <template slot="header">
              <div class="buttons is-right">
                <button class="delete" @click="closeTreeDeleteModal"></button>
              </div>
            </template>
            <p>本当にこのツリーを削除しますか？</p>
            <template slot="footer">
              <div class="buttons is-centered">
                <button class="button" @click="closeTreeDeleteModal">キャンセル</button>
                &nbsp;
                &nbsp;
                &nbsp;
                <button class="button is-link" @click="doTreeDelete">削除</button>
              </div>
            </template>
          </modalWindow>
        </div>
        <div class="share-modal-window">
          <modalWindow @close="colseCopyModal" v-if="enableCopyModal">
            <template slot="header">
              <div class="buttons is-right">
                <button class="delete" @click="closeCopy"></button>
              </div>
            </template>
            <input class="input is-link is-centered is-size-7" type="text" v-bind:class="{'has-text-danger':isCompletedCopy}" :value="directUrl">
            <template slot="footer">
              <div class="buttons is-centered">
                <button class="button share_copy" @click="copyConfirm" :data-clipboard-text="directUrl">
                  <p v-if="isCompletedCopy === true">
                    Copyしました
                  </p>
                  <p v-else>
                    <span class="icon is-small">
                      <i class="fa-solid fa-lg fa-copy" aria-hidden="true"></i>
                    </span>
                    <span>Copy</span>
                  </p>
                </button>
              </div>
            </template>
          </modalWindow>
        </div>
        <div class="anonymous-modal-window">
          <modalWindow v-if="isAnonymousModal">
            <template slot="header">
              <div class="buttons is-right">
                <button class="delete" @click="closeAnonymousModal()"></button>
              </div>
            </template>
            <p>ログインすると操作できます</p>
            <template slot="footer">
              <router-link class="buttons is-centered" @click.native="clickSetViewingPage()" to="/login">
                <button class="button is-link">Loginページへ</button>
              </router-link>
              <br>
            </template>
          </modalWindow>
        </div>
      </div>
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// src/pages/tree/Tree.vue